// Filename - pages/index.js

import React from "react";
import { Link } from "react-router-dom";
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import DownloadButton from "./downloadButton";

const Home = () => {
  return (
    <div>
      <h1>Pas trycias's portfolio</h1>
      <p>Bienvenue sur mon portfolio !</p>
      <p>Explorez mes projets et découvrez mon travail.</p>
      <p>Si vous avez des questions ou des projets à me proposer, n'hésitez pas à me contacter.</p>
      <p>Merci de votre visite !</p>
      <section>
        <details open>
          <summary><h2>Projets mobiles</h2></summary>
          <h3>2025 :[In development Phase] TeaseMeUp</h3>
          <details close>
            <summary><h3>2026 : Calendrier de l'Advent</h3></summary>
            <div className="project-details-container">
              <div className="project-links">
                <h4>Links:</h4>
                <ul>
                  <li>
                    <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.advent_calendar_2026" Icon={FaGooglePlay} />
                    <DownloadButton platform="iOS" link="https://apps.apple.com/fr/app/happy-now/id6751139746" Icon={FaApple} />
                    <DownloadButton platform="Instagram" link="https://www.instagram.com/happynowtheapp/" image="/logos/instagram.svg" />
                  </li>
                  <li><Link to="/advent"><img src="/2025_LetBeHappier.png" alt={`Calendrier de l'avent - logo`} className="image-button" /></Link></li>
                </ul>
              </div>
              <div className="project-description">
                <h4>Description:</h4>
                <p>Un Calendrier de l'Advent personnalisé par votre entourage pour vous.</p>
                <p>Invitez vos amis, votre famille et construisez une super expérience pour vos proches et vous</p>
              </div>
            </div>
          </details>
          <details close>
            <summary><h3>2025 : Happy Now</h3></summary>
            <div className="project-details-container">
              <div className="project-links">
                <h4>Links:</h4>
                <ul>
                  <li>
                    <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.better.letgetbetter" Icon={FaGooglePlay} />
                    <DownloadButton platform="iOS" link="https://apps.apple.com/fr/app/happy-now/id6751139746" Icon={FaApple} />
                    <DownloadButton platform="Instagram" link="https://www.instagram.com/happynowtheapp/" image="/logos/instagram.svg" />
                  </li>
                  {/* <li><DownloadButton platform="Instagram" link="" image="/logos/instagram.svg" />
                    <DownloadButton platform="TikTok" link="#" image="/logos/tiktok.svg" />
                    <DownloadButton platform="Youtube" link="#" image="/logos/youtube.svg" /></li> */}
                  <li><Link to="/HappyNow"><img src="/2025_LetBeHappier.png" alt={`Happy Now - logo`} className="image-button" /></Link></li>
                </ul>
              </div>
              <div className="project-description">
                <h4>Description:</h4>
                <p>Une recherche de Martin E. P. Seligman and Tracy A. Steen (University of Pennsylvania), Nansook Park (University of Rhode Island), Christopher Peterson  à montrer que prendre quelques minutes soir pour écrire 3 choses positives qui nous sont arrivées dans la journée aurait des impacts sur notre niveau de bonheur.<br />
                  Alors s'il n'y a que ça pour nous rendre plus heureux ...essayons. <br />
                  Biensûre qu'un papier et un crayson et hop on le fait ... avec une notification de rappel...ça marche déjà mieux, non ?<br />
                  C'est une expérience à faire, on en reparle après ?</p>
                <p><h5>Notes </h5>
                  <ul>
                    <li>ResearchGate : <a href="https://www.researchgate.net/publication/7701091_Positive_Psychology_Progress_Empirical_Validation_of_Interventions" target="_blank" rel="noopener noreferrer">Positive Psychology: Progress, Empirical Validation of Interventions</a></li>
                    <li>Se Réaliser : <a href="https://se-realiser.com/3-choses-positives-par-jour/" target="_blank" rel="noopener noreferrer">3 choses positives par jour : augmentez votre bonheur !</a></li>
                    <li>Wikipédia : <a href="https://fr.wikipedia.org/wiki/Pens%C3%A9e_positive" target="_blank" rel="noopener noreferrer">Pensée positive</a></li>
                    <li>... on est jamais mieux servit que par soit-même, faites vos recherches, faites vous votre avis .. </li>
                  </ul>
                </p>
              </div>
            </div>
          </details>
          <details close>
            <summary><h3>2025 : DdoubleCam</h3></summary>
            <div className="project-details-container">
              <div className="project-links">
                <h4>Links:</h4>
                <ul>
                  <li>
                    <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.doublecam" Icon={FaGooglePlay} />
                    <DownloadButton platform="iOS" link="https://apps.apple.com/us/app/ddoublecam/id6749810574" Icon={FaApple} /></li>
                  <li><DownloadButton platform="Instagram" link="https://www.instagram.com/ddoubleca" image="/logos/instagram.svg" />
                    <DownloadButton platform="TikTok" link="https://www.tiktok.com/@ddoublecam" image="/logos/tiktok.svg" />
                    <DownloadButton platform="Youtube" link="https://www.youtube.com/@DdoubleCam/shorts" image="/logos/youtube.svg" /></li>
                  <li><Link to="/ddoublecam"><img src="/2025_ddoublecam.png" alt={`DdoubleCam - logo`} className="image-button" /></Link></li>
                </ul>
              </div>
              <div className="project-description">
                <h4>Description:</h4>
                <p>Un appareil photo qui prend instantanément une photo avec votre caméra avant ET arrière...puis vous permet de monter l'assemblage.<br />
                  Ainsi vous pouvez choisir la photo front ou back en arrière plan, vous pouvez positionner la photo miniature au meilleur endroit dessus<br />
                  Bref, un appareil photo immersif pour partager ce que vous voyez autant que l'émotion qu'elle vous procure</p>
              </div>
            </div>
          </details>
          <details close >
            <summary><h3>2024 :[Deprecated] Calendrier de l'avent</h3></summary>
            <div className="project-details-container">
              <div className="project-links">
                <h4>Links:</h4>
                <ul>
                  <li><a href="https://advent2.web.app/" target="_blank" rel="noopener noreferrer">Website</a></li>
                  <li><a href="https://apps.apple.com/us/app/advent-calendar/id6738136524" target="_blank" rel="noopener noreferrer">Apple Store</a></li>
                  <li><a href="https://play.google.com/store/apps/dev?id=8746326719440724323" target="_blank" rel="noopener noreferrer">Google Play Store</a></li>
                  <li><img src="/2024_calendrier_avent.png" alt={`Calendrier de l'avent - Deprecated`} className="logo" /></li>
                </ul>
              </div>
              <div className="project-description">
                <h4>Description:</h4>
                <p>Un calendrier de l'avent collaboratif, un calendrier de l'avent rempli par les participants et les animateurs. Vous pouvez y accéder en utilisant le lien ci-dessous.</p>
                <p>Au lieu de trouver chaque jour un chocolat, on pouvait trouver des défis, des mots doux, des invitations, des rappels de souvenirs,... bref, une attention .</p>
                <p>Bref, une attention par jour de la part de votre entourage.</p>
              </div>
            </div>
          </details>
        </details>
      </section>
    </div>
  );
};

export default Home;